<template>
  <BaseReportTable
    :resultados="resultados"
    :total-items="totalItems"
    :items-por-pagina="itemsPorPagina"
    :pagina-actual="paginaActual"
    :loading="loading"
    :headers="anrHeaders"
    :es-operacion="esOperacion"
    @cambiar-pagina="$emit('cambiar-pagina', $event)"
    @cambiar-items-por-pagina="$emit('cambiar-items-por-pagina', $event)"
  >
    <!-- Template para legajo con link clicable -->
    <template v-slot:item.legajo="{ item }">
      <a
        v-if="item.legajo"
        :href="getGestionarUrl(item.legajo)"
        target="_blank"
        class="legajo-link"
      >
        {{ item.legajo }}
      </a>
      <template v-else>-</template>
    </template>

    <!-- Templates para columnas comunes con colores unificados -->
    <template v-slot:item.persona="{ item }">
      <v-chip
        small
        :color="item.persona === 'Física' ? 'blue' : 'purple'"
        text-color="white"
      >
        {{ item.persona || '-' }}
      </v-chip>
    </template>

    <template v-slot:item.estado="{ item }">
      <v-chip
        small
        :color="obtenerColorEstado(item.estado)"
        text-color="white"
      >
        {{ item.estado || '-' }}
      </v-chip>
    </template>

    <!-- Templates específicos para ANR -->
    <template v-slot:item.monto_total_solicitado="{ item }">
      ${{
        formatoNumero(getTipoMonto(item.parametros, 'monto_total_solicitado'))
      }}
    </template>

    <template v-slot:item.monto_aprobado="{ item }">
      ${{ formatoNumero(getTipoMonto(item.parametros, 'monto_aprobado')) }}
    </template>

    <template v-slot:item.monto="{ item }">
      ${{ formatoNumero(getMontoOtorgadoANR(item)) }}
    </template>

    <!-- Templates para desembolsos dinámicos -->
    <template v-slot:item.desembolso_1="{ item }">
      <div v-if="getDesembolso(item, 1)" class="desembolso-column">
        <div class="desembolso-monto">
          ${{ formatoNumero(getDesembolso(item, 1).monto) }}
        </div>
      </div>
      <div v-else class="text-center">-</div>
    </template>

    <template v-slot:item.fecha_desembolso_1="{ item }">
      <div
        v-if="getDesembolso(item, 1) && getDesembolso(item, 1).fecha_desembolso"
        class="desembolso-fecha"
      >
        {{ getDesembolso(item, 1).fecha_desembolso }}
      </div>
      <div v-else class="text-center">-</div>
    </template>

    <template v-slot:item.desembolso_2="{ item }">
      <div v-if="getDesembolso(item, 2)" class="desembolso-column">
        <div class="desembolso-monto">
          ${{ formatoNumero(getDesembolso(item, 2).monto) }}
        </div>
      </div>
      <div v-else class="text-center">-</div>
    </template>

    <template v-slot:item.fecha_desembolso_2="{ item }">
      <div
        v-if="getDesembolso(item, 2) && getDesembolso(item, 2).fecha_desembolso"
        class="desembolso-fecha"
      >
        {{ getDesembolso(item, 2).fecha_desembolso }}
      </div>
      <div v-else class="text-center">-</div>
    </template>

    <template v-slot:item.desembolso_3="{ item }">
      <div v-if="getDesembolso(item, 3)" class="desembolso-column">
        <div class="desembolso-monto">
          ${{ formatoNumero(getDesembolso(item, 3).monto) }}
        </div>
      </div>
      <div v-else class="text-center">-</div>
    </template>

    <template v-slot:item.fecha_desembolso_3="{ item }">
      <div
        v-if="getDesembolso(item, 3) && getDesembolso(item, 3).fecha_desembolso"
        class="desembolso-fecha"
      >
        {{ getDesembolso(item, 3).fecha_desembolso }}
      </div>
      <div v-else class="text-center">-</div>
    </template>

    <template v-slot:item.desembolso_4="{ item }">
      <div v-if="getDesembolso(item, 4)" class="desembolso-column">
        <div class="desembolso-monto">
          ${{ formatoNumero(getDesembolso(item, 4).monto) }}
        </div>
      </div>
      <div v-else class="text-center">-</div>
    </template>

    <template v-slot:item.fecha_desembolso_4="{ item }">
      <div
        v-if="getDesembolso(item, 4) && getDesembolso(item, 4).fecha_desembolso"
        class="desembolso-fecha"
      >
        {{ getDesembolso(item, 4).fecha_desembolso }}
      </div>
      <div v-else class="text-center">-</div>
    </template>

    <template v-slot:item.desembolso_5="{ item }">
      <div v-if="getDesembolso(item, 5)" class="desembolso-column">
        <div class="desembolso-monto">
          ${{ formatoNumero(getDesembolso(item, 5).monto) }}
        </div>
      </div>
      <div v-else class="text-center">-</div>
    </template>

    <template v-slot:item.fecha_desembolso_5="{ item }">
      <div
        v-if="getDesembolso(item, 5) && getDesembolso(item, 5).fecha_desembolso"
        class="desembolso-fecha"
      >
        {{ getDesembolso(item, 5).fecha_desembolso }}
      </div>
      <div v-else class="text-center">-</div>
    </template>

    <template v-slot:item.fecha_desembolso_6="{ item }">
      <div
        v-if="getDesembolso(item, 6) && getDesembolso(item, 6).fecha_desembolso"
        class="desembolso-fecha"
      >
        {{ getDesembolso(item, 6).fecha_desembolso }}
      </div>
      <div v-else class="text-center">-</div>
    </template>

    <template v-slot:item.fecha_desembolso_7="{ item }">
      <div
        v-if="getDesembolso(item, 7) && getDesembolso(item, 7).fecha_desembolso"
        class="desembolso-fecha"
      >
        {{ getDesembolso(item, 7).fecha_desembolso }}
      </div>
      <div v-else class="text-center">-</div>
    </template>

    <template v-slot:item.monto_pendiende="{ item }">
      ${{ formatoNumero(getPendienteDesembolso(item)) }}
    </template>

    <!-- Slot personalizado para totales ANR -->
    <template v-slot:totals-row="{ totals }">
      <!-- Total Monto Solicitado -->
      <td>
        <strong class="totals-text">$ {{ formatoNumero(getTotalMontoSolicitadoANR()) }}</strong>
      </td>
      <!-- Total Monto Aprobado -->
      <td>
        <strong class="totals-text">$ {{ formatoNumero(totals.totalMontoAprobado || 0) }}</strong>
      </td>
      <!-- Total Monto Otorgado -->
      <td>
        <strong class="totals-text">$ {{ formatoNumero(getTotalMontoOtorgadoANR()) }}</strong>
      </td>
      <!-- Total Monto Pendiente -->
      <td>
        <strong class="totals-text">$ {{ formatoNumero(totalMontoPendiente || 0) }}</strong>
      </td>

      <!-- Totales dinámicos de desembolsos (monto y fecha por cada desembolso) -->
      <template v-for="i in maxDesembolsos">
        <td :key="`desembolso-${i}`">
          <strong class="totals-text">$ {{ formatoNumero(getTotalDesembolso(i)) }}</strong>
        </td>
        <td :key="`fecha-${i}`"></td>
      </template>

      <!-- Totales de gastos con nombres específicos -->
      <td v-if="shouldIncludeGastos">
        <strong class="totals-text">$ {{ formatoNumero(totals.totalGastoAdministrativo) }}</strong>
      </td>
      <td v-if="shouldIncludeGastos">
        <strong class="totals-text">$ {{ formatoNumero(totals.totalGastoOtorgamiento) }}</strong>
      </td>
      <td v-if="shouldIncludeGastos">
        <strong class="totals-text">$ {{ formatoNumero(totals.totalGastoIibb) }}</strong>
      </td>
    </template>
  </BaseReportTable>
</template>

<script>
import BaseReportTable from './BaseReportTable.vue';
import ReportCalculations from '../ReportCalculations';

export default {
  name: 'ANRReportTable',
  components: {
    BaseReportTable,
  },
  mixins: [ReportCalculations],
  props: {
    resultados: {
      type: Array,
      default: () => [],
    },
    totalItems: {
      type: Number,
      default: 0,
    },
    itemsPorPagina: {
      type: Number,
      default: 10,
    },
    paginaActual: {
      type: Number,
      default: 1,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    headers: {
      type: Array,
      default: () => [],
    },
    esOperacion: {
      type: String,
      default: 'ANR',
    },
  },
  emits: ['cambiar-pagina', 'cambiar-items-por-pagina'],
  computed: {
    anrHeaders() {
      const baseHeaders = [...this.headers];

      // Agregar columnas dinámicas de desembolsos para ANR
      for (let i = 1; i <= this.maxDesembolsos; i++) {
        baseHeaders.push({
          text: `Desembolso ${i}`,
          value: `desembolso_${i}`,
          sortable: false,
        });
        baseHeaders.push({
          text: `Fecha Desembolso ${i}`,
          value: `fecha_desembolso_${i}`,
          sortable: false,
        });
      }

      // Agregar columnas de gastos con nombres específicos
      if (this.shouldIncludeGastos) {
        baseHeaders.push({
          text: 'Honorarios MF',
          value: 'honorarios_mf',
          sortable: false,
        });
        baseHeaders.push({
          text: 'Gastos de Escribano',
          value: 'gastos_escribano',
          sortable: false,
        });
        baseHeaders.push({
          text: 'Otros Gastos',
          value: 'otros_gastos',
          sortable: false,
        });
      }

      return baseHeaders;
    },
    incluyeMontoAprobado() {
      return this.headers.some((header) => header.value === 'monto_aprobado');
    },
    shouldIncludeGastos() {
      return this.resultados.some((item) => item.gastos);
    },
  },
  methods: {
    getGestionarUrl(legajo) {
      const baseUrl = process.env.VUE_APP_GESTIONAR_URL || 'http://localhost:8080';
      return `${baseUrl}/gestionar/${legajo}`;
    },
    obtenerColorEstado(estado) {
      const colores = {
        Otorgado: 'green',
        Aprobado: 'blue',
        Análisis: 'orange',
        Rechazado: 'red',
        Cancelado: 'grey',
        Desistido: 'brown',
      };
      return colores[estado] || 'grey';
    },
    getMontoOtorgadoANR(item) {
      if (!item || !item.desembolsos || !Array.isArray(item.desembolsos)) {
        return 0;
      }

      // Sumar todos los desembolsos realizados para obtener el monto otorgado
      return item.desembolsos.reduce((total, desembolso) => {
        return total + (parseFloat(desembolso.monto) || 0);
      }, 0);
    },
    getTotalMontoOtorgadoANR() {
      if (!this.resultados || !Array.isArray(this.resultados)) {
        return 0;
      }

      return this.resultados.reduce((total, item) => {
        return total + this.getMontoOtorgadoANR(item);
      }, 0);
    },
    getTotalMontoSolicitadoANR() {
      if (!this.resultados || !Array.isArray(this.resultados)) {
        return 0;
      }

      return this.resultados.reduce((total, item) => {
        const montoSolicitado = this.getTipoMonto(item.parametros, 'monto_total_solicitado');
        return total + (parseFloat(montoSolicitado) || 0);
      }, 0);
    },
  },
};
</script>

<style scoped>
.desembolso-column {
  text-align: center;
}

.desembolso-monto {
  font-size: 0.9em;
}

.desembolso-fecha {
  font-size: 0.8em;
  color: #6c757d;
}

.legajo-link {
  color: #1976d2;
  text-decoration: none;
  font-weight: 500;
}

.legajo-link:hover {
  color: #1565c0;
  text-decoration: underline;
}
</style>
